/* eslint-disable quotes */
const DEFAULT_CACHE_NAME = "api-cache-v1";

const CacheService = {
  async get(key, { cacheName = DEFAULT_CACHE_NAME, ttlMs = 864e5 } = {}) {
    if (!("caches" in window)) return null;

    try {
      const cache = await caches.open(cacheName);
      const cached = await cache.match(key);
      if (!cached || !cached.ok) return null;

      const payload = await cached
        .clone()
        .json()
        .catch(() => null);
      if (!payload || !payload.data) return null;

      const now = Date.now();
      if (payload.ts && now - payload.ts < ttlMs) {
        return payload.data;
      }

      // Expired
      await cache.delete(key);
      return null;
    } catch (err) {
      console.warn("[CacheService] Error leyendo cache:", err);
      return null;
    }
  },

  async set(key, data, { cacheName = DEFAULT_CACHE_NAME } = {}) {
    if (!("caches" in window)) return false;
    try {
      const cache = await caches.open(cacheName);
      const payload = { ts: Date.now(), data };
      const resp = new Response(JSON.stringify(payload), {
        headers: { "Content-Type": "application/json" },
      });
      await cache.put(key, resp);
      return true;
    } catch (err) {
      console.warn("[CacheService] Error guardando cache:", err);
      return false;
    }
  },

  async delete(key, { cacheName = DEFAULT_CACHE_NAME } = {}) {
    if (!("caches" in window)) return false;
    const cache = await caches.open(cacheName);
    return cache.delete(key);
  },

  async clearAll({ cacheName = DEFAULT_CACHE_NAME } = {}) {
    if (!("caches" in window)) return false;
    return caches.delete(cacheName);
  },
};

export default CacheService;
